import { HtmlHTMLAttributes, memo } from "react";
import { AvailableFonts } from "../fonts";

export type SignatureCardProps = HtmlHTMLAttributes<HTMLDivElement> & {
  font: AvailableFonts
}

export const SignatureCard = memo<SignatureCardProps>(({ font, children, ...props }) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        fontFamily: font,
      }}
    >
      {children}
    </div>
  );
});

export default SignatureCard;